export default {
  es: {
    TRY_AGAIN: 'Intentar de nuevo',
    CHOOSE_PAYMENT_METHOD: '¿Cómo quieres pagar?',
    BUY_NOW: 'Comprar ahora',

    // Coupon
    COUPON_TITLE: '¿Tienes un cupón de descuento?',
    COUPON_LABEL: 'Ingresa tu cupón',
    COUPON_BUTTON_LABEL: 'Aplicar cupón',
    COUPON_APPLIED: 'Cupón aplicado',
    COUPON_SNACKBAR_TITLE: 'Has aplicado tu cupón',
    INVALID_COUPON: 'Cupón no es válido',

    // Paypal
    PAYPAL_DESCRIPTION:
      'Para seguir con tu compra inicia sesión con tu cuenta de Paypal',

    // Pagoefectivo - Peru
    PAGO_EFECTIVO_TITLE: 'Selecciona tu método de pago',
    PAGO_EFECTIVO_INSTITUTIONS: 'Puedes realizar tus pagos en',
    PAGO_EFECTIVO_TRANSFER:
      '¿Cómo hacer una transferencia bancaria a través de Pago Efectivo?',
    PAGO_EFECTIVO_DEPOSIT:
      '¿Cómo hacer un depósito en efectivo a través de Pago Efectivo?',

    //  Mexico offline,
    MX_OFFLINE_SELECT_STORE: 'Selecciona tu tienda preferida',
    MX_OFFLINE_TITLE_1: 'Realiza tu pago en cualquier',
    MX_OFFLINE_TITLE_2: 'de la república',
    MX_OFFLINE_MAX_AMOUNT: 'Monto máximo: MX$ {{maxAmount}}',
    MX_OFFLINE_COMMISSION: 'Comisión {{storeName}}: MX$ {{amount}}',
    MX_OFFLINE_OXXO:
      'Una vez que confirme la compra, te enviaremos los datos a tu correo electrónico y por mensaje de texto. Recuerda que solo tienes 72 horas para realizar el pago en cualquier OXXO',
    MX_OFFLINE_SPEI:
      'Una vez que confirme la compra, te enviaremos los datos a tu correo eléctronico. Recuerda que solo tienes 72 horas para realizar el pago en cualquier SPEI',

    // COLOMBIA OFFLINE
    CO_OFFLINE_TITLE: 'Realiza tu pago en cualquier {{methodName}} del país.',
    CO_OFFLINE_DESCRIPTION:
      'Al hacer el pago en {{methodName}}, informa que está dirigido a Crehana. El número de referecia es tu número de pedido. Una vez transcurridas 72 horas será cancelado automaticamente',
    CO_DOCUMENT_LABEL: 'Tipo de documento',

    // pending offline payment
    PENDING_OFFLINE_TITLE: '¡Ya tienes generado un número de tarjeta de pago!',
    PENDING_OFFLINE_DESCRIPTION:
      'Por favor revisa tu correo electrónico para poder ver toda la información.',
    PENDING_OFFLINE_INFO:
      'Una vez realizado el pago, tu compra será activada en un plazo de 24hrs. ',

    // successful offline payment
    SUCCESSFULL_TITLE:
      'Presenta este número en {{storeName}} para realizar tu pago.',
    SUCCESSFULL_SUBTITLE: 'Número de tarjeta',
    SUCCESSFULL_AGREEMENT_NUMBER: 'Número de convenio ',
    SUCCESSFULL_REFERENCE_CODE: 'Código de referencia ',
    SUCCESSFULL_PRINT: 'Imprime tu recibo de pago.',
    SUCCESSFULL_DATE_LABEL: 'Tu fecha límite de pago es:',
    SUCCESSFULL_TIMEOUT_LABEL:
      'Una vez hecho el pago tu compra se activará en un plazo de 24hrs',
    SUCCESSFULL_WITHOUT_COMMISSION: 'No incluye comisión de {{storeName}}',
    SUCCESSFULL_WITH_COMMISSION: 'Incluye comisión de SPEI',
    SUCCESSFULL_INFO: 'Pagar únicamente en {{storeName}}.',
    SUCCESSFULL_BENEFIT: 'Lo que aprendas hoy te ayudará a superarte mañana.',
    SUCCESSFULL_CONEKTA_OXXO:
      'Presenta este número en OXXO para realizar tu pago e indica que el pago se realizará mediante Conekta.',

    // card number
    CARD_NUMBER_LABEL: 'Número de Tarjeta',
    REQUIRED_CARD_NUMBER: 'El número de tu tarjeta es obligatorio',
    INVALID_CARD_NUMBER: 'Tu tarjeta es inválida, intentalo de nuevo',
    INCORRECT_CARD_NUMBER: 'Tu tarjeta es incorrecta, intentalo de nuevo',
    INCOMPLETE_CARD_NUMBER: 'Tu número de tarjeta está incompleto',
    ERROR_CARD_BIN: 'Intenta consultar otra vez por la promocíon',
    CARD_DECLINED: 'Tarjeta declinada, comunícate con tu banco.',

    // card expiration date
    EXPIRATION_DATE_LABEL: 'MM/AA',
    REQUIRED_EXPIRATION_DATE: 'La fecha es obligatoria',
    INVALID_EXPIRATION_DATE: 'Ingresa una fecha válida',

    // cvv
    CVC_CVV_LABEL: 'CVC/CVV',
    REQUIRED_CVC_CVV: 'CVC/CVV obligatorio',
    INVALID_CVC_CVV: 'CVC/CVV inválido',
    INCORRECT_CVC_CVV: 'CVC/CVV incorrecto',

    // user address
    USER_ADDRESS_LABEL: 'Dirección completa',
    REQUIRED_USER_ADDRESS: 'Debes indicar una dirección válida',

    // province
    PROVINCE_NAME_LABEL: 'Provincia',
    REQUIRED_PROVINCE_NAME: 'Debes indicar el nombre de tu provincia',

    // department
    DEPARTMENT_NAME_LABEL: 'Departamento',
    REQUIRED_DEPARTMENT_NAME: 'Debes indicar el nombre de tu departamento',

    // city
    CITY_NAME_LABEL: 'Ciudad',
    REQUIRED_CITY_NAME: 'Debes indicar el nombre de tu ciudad',

    // state name
    STATE_NAME_LABEL: 'Estado',
    REQUIRED_STATE_NAME: 'Debes indicar el nombre de tu estado',

    // zip code
    ZIP_CODE_LABEL: 'Código postal',
    REQUIRED_ZIP_CODE: 'Código postal obligatorio',
    INVALID_ZIP_CODE: 'El código postal no es válido',

    // phone number
    PHONE_NUMBER_LABEL: 'Número de teléfono',
    REQUIRED_PHONE_NUMBER: 'Número de teléfono móvil obligatorio',
    INVALID_PHONE_NUMBER: 'Número de teléfono inválido',
    INCOMPLETE_PHONE_NUMBER: 'Número de teléfono incompleto',

    // card holder
    CARD_HOLDER_LABEL: 'Titular de la tarjeta',
    REQUIRED_CARD_HOLDER: 'Nombre en la tarjeta obligatorio',

    EMAIL_LABEL: 'Correo electrónico',
    EMAIL_PLACEHOLER: 'Ingresa tu correo electrónico',
    REQUIRE_EMAIL: 'Correo electrónico obligatorio',

    FULLNAME_LABEL: 'Nombres y apellidos', // pt
    OFFLINE_BUTTON_LABEL: 'Generar código',
    NEXT_FORM: 'Continuar',
    PREVIOUS_FORM: 'Volver a datos personales',

    // document
    IDENTITY_DOCUMENT_LABEL: 'Documento de identidad',
    REQUIRED_IDENTITY_DOCUMENT: 'Documento obligatorio',
    INVALID_IDENTITY_DOCUMENT: 'El número del documento está mal escrito',
    INCOMPLETE_IDENTITY_DOCUMENT: 'Documento incompleto',

    // fullname
    FULLNAME: 'Nombre completo',
    REQUIRED_FULLNAME: 'Nombre completo obligatorio',
    INVALID_FULLNAME: 'Nombre completo inválido',

    // steps
    PERSONAL_INFO: 'Datos personales',
    CARD_INFO: 'Datos de la tarjeta',
    ACTIVATION: 'Activa tu compra',
    LAST_STEP: '¡Comienza a aprender!',
    PAYMENT_STEP: 'Proceso de pago',
    DELIVERY_STEP: 'Datos de envio',

    GO_SAVED_CARD: 'Paga con tarjeta guardada',
    GO_BACK: 'Atrás',
    GO_BACK_2: 'Regresar',
    DEFAULT_PAYMENT_ERROR:
      '¡El pago no puede ser procesado! Te recomendamos comunicarte con tu banco para más detalles.',
    CARD_SAVED_ERROR:
      'No se ha podido guardar tu tarjeta. Te recomendamos comunicarte con tu banco para más detalles.',
    ERROR_GENERATE_CODE:
      '¡El código no puede ser generado! inténtalo otra vez.',
    PUBLIC_KEY_NO_FOUND: 'Clave pública no encontrada',
    PAYMENT_WARNING:
      '¡Tu pago ha sido realizado! Sin embargo tenemos problemas con el sistema. Un miembro de nuestro equipo solucionará tu caso. Comunícate a ',
    CREHANA_EMAIL: 'hola@crehana.com',
    ADD_SAVED_CARD: 'Agregar nueva tarjeta',
    OFFLINE_ERROR_MESSAGE:
      'Hubo un error al generar tu número de compra, inténtalo de nuevo.',
    QUICK_ENROLL_INFO:
      'Recuerda que se usara la totalidad de tu crédito para esta compra.',
    QUICK_BUTTON_LABEL: 'Empezar ahora',
    GUARANTEE_INFO:
      'Si tu experiencia con la compra no es lo que esperabas, te haremos un reembolso del 100% de tu pago. Por favor revisar nuestras',
    MS_GUARANTEE_SHORT:
      'Te devolvemos tu compra al 100% si no estás contento con tu membresía.*',
    PAYG_GUARANTEE_SHORT:
      'Te devolvemos tu pago al 100% si no estás contento con tu compra.*',
    CATCH_MESSAGE: '¡El pago no puede ser procesado!, inténtalo otra vez',
    CHECKOUT_GENERIC_ERROR:
      '¡El pago no puede ser procesado!, inténtalo otra vez',
    CATCH_MESSAGE_COUPON:
      '¡El cupón no puede ser procesado!, inténtalo otra vez',
    PAYMENT_DISCLAIMER:
      'El cobro va a ser de US$ {{totalToPayInDollars}}, los precios base que manejamos son en dólares americanos. El monto que ves en tu moneda local es un aproximado que puede variar de acuerdo a tu banco y el tipo de cambio del día, está sujeto a impuestos propios de cada país, los cuales serán asumidos por los usuarios finales.',
    TERMS_CONDITIONS_TITLE: 'Términos y condiciones',
    TERMS_CONDITIONS_DESCRIPTION:
      '(1) Acepto expresamente todos los Términos y Condiciones de Membresías Premium y Pay As You Go. Del mismo, modo acepto las Políticas y Avisos de Protección y Tratamiento de Datos Personales de Crehana: Generales, Colombia, México.',
    SHORT_PAYMENT_TAG: 'Total',
    LONG_PAYMENT_TAG: 'Total a pagar',
    PAYMENT_FORM_TITLE: 'Ingresa los datos de tu tarjeta',
    TIMER_LABEL: 'La oferta termina en',
    SAFE_LABEL: 'Pago 100% seguro',
    GREETING: 'Hola',
    ADVISOR_LABEL: 'Tu asesor educativo',
    EXPIRATION_DESCRIPTION:
      'La oferta que buscas ya no se encuentra disponible, si deseas puedes volver a comunicarte con tu asesor educativo:',
    PROMOTION_MESSAGE:
      'Oferta válida sólo durante la llamada con el agente educativo',
    EXPIRATION_EMAIL_TAG: 'Comunicarme',
    CONTACT_US:
      'Si tienes alguna duda, puedes comunicarte con nosotros de Lunes a Viernes, desde las 09:00 am hasta las 7:00 pm',
    DISCOUNT_TAG: 'Primera compra',
    CREDIT_TAG: 'Créditos',
    CASHBACK_TAG: 'Cashback',
    SUBTOTAL_TAG: 'Subtotal',
    CHECKBOX_LEGAL: 'expresamente todos los',
    CHECKBOX_LEGAL_FULL:
      'expresamente todos los Términos y Condiciones de la Membresía Premium.',
    LEGAL_LINK_TEXT: 'Términos y condiciones',
    LEGAL_ERROR_TEXT:
      'Necesitas aceptar los términos y condiciones para continuar.',
    CHECKBOX_LABEL: 'Acepto ',
    DEGREE_GUARANTEE:
      'En caso tu experiencia con el MicroDegree no cumpla con tus expectativas y deseas solicitar una devolución, debes tener en consideración las',
    REFUND_POLICIES: 'Políticas de Reembolso.',
    DEGREE_BENEFIT_TITLE: '¿Por qué llevar nuestros MicroDegrees?',
    BOOTCAMP_BENEFIT_TITLE: '¿Por qué llevar nuestros Bootcamps?',
    DEGREE_BENEFIT_1:
      'Certificado online por partners universitarios reconocidos en Latinoamérica',
    DEGREE_BENEFIT_2: 'Duración de 4 meses',
    BOOTCAMP_BENEFIT_2: 'Duración de 1 mes',
    DEGREE_BENEFIT_3: 'Asesorías y mentorías en vivo',
    USERPROOF_LABEL:
      '¡Hay {{userQuantity}} personas que están comprando lo mismo que tú desde {{countryName}}!',
    CAMPAIGN_TIMER_LABEL: '¡Queda poco tiempo!',
    PAYMENT_DETAIL_TITLE: 'Información de pago',
    // Checkout V4
    LABEL_HEADER_CHECKOUT: '¿Estás seguro que quieres salir?',
    BUTTON_LABEL_HEADER_CHECKOUT_1: 'Ir a la página anterior',
    BUTTON_LABEL_HEADER_CHECKOUT_2: 'Quedarme aquí',
    // premium benefit
    PREMIUM_BENEFIT_1: 'Acceso a +1000 cursos y especializaciones',
    PREMIUM_BENEFIT_2: 'Mentorías y contenido exclusivo',
    PREMIUM_BENEFIT_3: 'Válida por {{yearNumber}} año, autorenovable',
    PREMIUM_BENEFIT_4: 'Válida por {{monthNumber}} meses, autorenovable',
    LITE_BENEFIT: 'Válida por {{monthNumber}} meses',

    // Legals
    MOBILE_GUARANTEE_TITLE: '* Garantía de 14 días',
    MOBILE_DISCLAIMER_TITLE: 'Sobre el cobro',

    GO_PAYMENT_METHODS: 'Otros métodos de pago',
    CHECKBOX_DATA_USAGE:
      'Autorizo que Crehana use los datos proporcionados para contactarme y recibir promociones, ofertas e información de nuevos productos.',

    // Payment errors
    INSUFFICIENT_FUNDS:
      'Nuestro sistema nos indica que tienes fondos insuficientes.',
    EXPIRED_CARD: 'Tu tarjeta ha expirado, comunícate con tu banco.',
    INVALID_INFO_CARD: 'Tu tarjeta es incorrecta, intentalo de nuevo',
    INVALID_CARD: 'Tu tarjeta es inválida, intentalo de nuevo',

    // Crehana errors
    DEACTIVATE_SUBSCRIPTION: 'La membresia no está activa',
    ALREADY_PURCHASED: 'Ya cuentas con este curso en tu cuenta',
    PENDING_PAYMENT_CODE: 'Ya cuentas con un pago pendiente',
    ALREADY_ITEM_PENDING_CODE:
      'Ya cuentas con una orden pendiente para este producto',
    INVALID_ITEM: 'El producto que desea comprar no es válido',

    // Saved Cards
    CVV_VALIDATION:
      'Para validar tu compra con esta tarjeta, necesitamos que escribas el código de seguridad',

    // Payments Loader
    PROCESSING_PAYMENT: 'Procesando compra ...',
    VERIFYING_PAYMENT: 'Verificando pago ...',
    COMPLETING_TRANSACTION: 'Completando transacción ...',
    GENERATING_CODE: 'Generando código ...',
    GENERATING_DATA: 'Generando datos ...',

    // User input fields
    DOCUMENT_DROPDOWN_HINT: 'Seleccione el tipo de documento',
    DOCUMENT_TYPE_LABEL: 'Tipo de documento',
    REQUIRED_FIELD: 'Campo obligatorio',

    CHOOSE_QUOTA: 'Elige tus mensualidades',
    // Hot sale
    HOT_SALE_MESSAGE: '¡No dejes pasar esta oportunidad!',

    // Countdown
    DAYS_LABEL: 'Días',
    HOURS_LABEL: 'Horas',
    MINUTES_LABEL: 'Mins',
    SECONDS_LABEL: 'Segs',
  },
};
